export const version = '2.11.0';
/**
 * channel options for react-hooks
 */
export function channelOptionsForReactHooks(options) {
    return Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, options === null || options === void 0 ? void 0 : options.params), { agent: `react-hooks/${version}` }), 
        // we explicitly attach channels in React hooks (useChannel, usePresence, usePresenceListener)
        // to avoid situations where implicit attachment could cause errors (when connection state is failed or disconnected)
        attachOnSubscribe: false });
}
//# sourceMappingURL=AblyReactHooks.js.map